<template>
  <div class="home">
    <!-- <div class="toplogo">
         <img class="mainlogo" src="../assets/logoSar.png">
         <img class="logosar" src="../assets/sar.png">
    </div> -->
    <Navbar></Navbar>
    <img class="heroimage" src="../assets/heroimage.png">
    <About></About>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from '@/components/Navbar.vue'
import About from '@/components/About.vue'
import Footer from '@/components/Footer.vue'


export default {
  name: 'home',
  components: {
    HelloWorld,
    Navbar,
    About,
    Footer
  }
}
</script>

<style>


  @media only screen and (max-width: 600px) {
  .mainlogo{
    width: 150px;
    margin-top: 30px;
    margin-left: 5px;
  }
    .logosar{
    width: 200px;
    float:right;
    margin-right: 20px;
    margin-top: 40px;
  }
}

  @media only screen and (min-width: 600px) {
  .mainlogo{
    width: 200px;
    margin-top: 30px;
    margin-left: 30px;
  }
  
  .logosar{
    width: 300px;
    margin-top: 40px;
    float:right;
    margin-right: 30px;
    position: relative;
  }

}

  .heroimage{
    width: 100%;
    margin-right: 80px;
  
  }


</style>

